import { createBaseSocket } from '@shared/api/baseSocket'
import { withSocketTicket } from '@shared/api'

const getSameOriginUserWsUrl = () => {
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  return `${protocol}//${window.location.host}/UserAccWS`
}

const resolveUserWsUrl = (configuredUrl: string | undefined) => {
  if (!configuredUrl) return getSameOriginUserWsUrl()

  const url = new URL(configuredUrl)
  const isLocalhostConfig = url.hostname === 'localhost' || url.hostname === '127.0.0.1'
  const isLocalhostPage = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'

  if (isLocalhostConfig && !isLocalhostPage) {
    return `${url.protocol}//${window.location.host}${url.pathname}${url.search}`
  }

  return configuredUrl
}

const USER_WS_URL = resolveUserWsUrl(import.meta.env.VITE_WS_USER_BASE_URL)

const createUserAccSocket = () => {
  let sendFn: ((msg: UserAccAuthMsg) => void) | null = null

  const base = createBaseSocket<UserAccAuthMsg, (msg: UserAccServerMessage) => void>(
    (raw, listeners) => {
      try {
        const msg = JSON.parse(raw) as UserAccServerMessage
        if (
          msg.cmd === 9001 ||
          msg.cmd === 2101 ||
          msg.cmd === 2102 ||
          msg.cmd === 2103 ||
          msg.cmd === 2104 ||
          msg.cmd === 2105 ||
          msg.cmd === 2110 ||
          msg.cmd === 4000
        ) {
          listeners.forEach(fn => fn(msg))
        }
      } catch {
        // 파싱 실패 무시
      }
    },
    USER_WS_URL,
    {
      prepareUrl: withSocketTicket,
      useAuthProtocols: false,
      // onOpen: 연결 완료(101) 시점에 인증 패킷 송신
      onOpen: () => {
        sendFn?.({ cmd: 9001 })
      },
    },
  )

  sendFn = base.send

  return { ...base }
}

export const userAccSocket = createUserAccSocket()
